import { DataGridPro } from '@cibo/ui'
import { GridColDef, GridValidRowModel } from '@mui/x-data-grid-pro'

const TRAIT_GRID_SX = {
  '.MuiDataGrid-columnHeaders': { fontSize: '16px' },
  '.MuiDataGrid-columnHeaderTitle': { fontWeight: '400' },
  '.MuiDataGrid-row:hover': { backgroundColor: 'rgba(24, 48, 56, 0.03)' },
  '.MuiDataGrid-row:hover .MuiDataGrid-cell--pinnedLeft': { backgroundColor: 'unset' },
  '.MuiDataGrid-cell--pinnedLeft': {
    borderRight: '1px solid rgba(224, 224, 224, 1)',
    boxShadow: '2px 0px 4px -2px #00000036',
  },
}

interface TraitDataGridProps {
  rows: GridValidRowModel[]
  columns: GridColDef[]
  hideFooter?: boolean
  apiRef?: any
}

export const TraitDataGrid = ({ rows, columns, hideFooter, apiRef }: TraitDataGridProps) => (
  <DataGridPro
    apiRef={apiRef}
    getRowHeight={() => 'auto'}
    rows={rows}
    columns={columns}
    hideFooter={hideFooter}
    initialState={{ pinnedColumns: { left: ['traitId'] } }}
    sx={TRAIT_GRID_SX}
  />
)
